import React from "react";
import { useNavigate } from "react-router-dom";
import { LayoutGrid, Orbit } from "lucide-react";
import { DASHBOARD_BASE } from "../../../config/featureFlags";
import { useDashTheme } from "../hooks/useDashTheme";

/**
 * Graphical ↔ Brain switch (2026-08-30). One control, mounted in both
 * dashboards' toolbars. The choice is remembered so /dashboard opens the
 * view the user last picked (see DashboardHome in App.js).
 */
export const DASH_VIEW_KEY = "tg.dashView";
export function readDashView() {
  try { return localStorage.getItem(DASH_VIEW_KEY) === "brain" ? "brain" : "graphical"; } catch (_) { return "graphical"; }
}
export function writeDashView(v) {
  try { localStorage.setItem(DASH_VIEW_KEY, v === "brain" ? "brain" : "graphical"); } catch (_) { /* private mode */ }
}

const VIEWS = [
  { key: "graphical", label: "Classic", icon: LayoutGrid, path: "/graphical", title: "Classic dashboard — graphs, drills and the day on a line" }, // label "Classic" (user, 2026-08-30); key/route unchanged
  { key: "brain", label: "Brain", icon: Orbit, path: "/brain", title: "Company Brain — the org as a living map, moves and live updates" },
];

export function DashViewSwitch({ value, size = "md", style }) {
  const t = useDashTheme();
  const navigate = useNavigate();
  const sm = size === "sm";
  return (
    <div role="tablist" aria-label="Dashboard view" style={{
      display: "inline-flex", padding: 3, borderRadius: sm ? 9 : 12, gap: 2,
      background: "var(--tgw-well, " + t.c.surfaceMuted + ")", border: `1px solid ${t.c.border}`, ...style,
    }}>
      {VIEWS.map((v) => {
        const on = v.key === value;
        const Icon = v.icon;
        return (
          <button
            key={v.key} type="button" role="tab" aria-selected={on} title={v.title}
            onClick={() => { if (on) return; writeDashView(v.key); navigate(`${DASHBOARD_BASE}${v.path}`); }}
            style={{
              display: "inline-flex", alignItems: "center", gap: 6,
              padding: sm ? "4px 9px" : "6px 12px", borderRadius: sm ? 7 : 9,
              fontSize: sm ? 12 : 12.5, fontWeight: 650, border: 0, cursor: on ? "default" : "pointer", fontFamily: t.font.family,
              background: on ? `var(--tgw-card, ${t.c.surface})` : "transparent",
              color: on ? t.c.text : t.c.textSecondary,
              boxShadow: on ? `0 1px 3px ${t.c.shadowColor}` : "none",
            }}
          >
            <Icon size={sm ? 12 : 13} style={{ color: on ? (v.key === "brain" ? t.c.ai : t.c.primary) : "inherit" }} />
            {v.label}
          </button>
        );
      })}
    </div>
  );
}

export default DashViewSwitch;
